import {AfterViewInit, Directive, ElementRef, EventEmitter, Input, NgZone, Output} from "@angular/core";
import {GestureController} from "@ionic/angular/standalone";
import {Haptics, ImpactStyle} from "@capacitor/haptics";

@Directive({
  selector: "[sxLongPress]",
  standalone: false
})
export class LongPressDirective implements AfterViewInit {

  @Output() press = new EventEmitter();
  @Input("delay") delay = 300;
  action: ReturnType<typeof setTimeout> | null = null;

  private longPressActive = false;
  // ponytail: block the tap ion-tab-button fires after a successful long press
  private blockNextActivation = false;
  private readonly blockActivation = (ev: Event) => {
    if (!this.blockNextActivation) {
      return;
    }
    ev.preventDefault();
    ev.stopImmediatePropagation();
    this.blockNextActivation = false;
  };

  constructor(
    private el: ElementRef,
    private gestureCtrl: GestureController,
    private zone: NgZone
  ) {
  }

  ngAfterViewInit() {
    const el = this.el.nativeElement;
    el.addEventListener('click', this.blockActivation, true);
    el.addEventListener('pointerup', this.blockActivation, true);
    this.loadLongPressOnElement();
  }

  loadLongPressOnElement() {
    const gesture = this.gestureCtrl.create({
      el: this.el.nativeElement,
      threshold: 0,
      gestureName: 'sxLongPress',
      onStart: () => {
        this.longPressActive = true;
        this.longPressAction();
      },
      onEnd: () => {
        this.longPressActive = false;
        this.clearLongPressTimer();
      }
    });
    gesture.enable(true);
  }

  private clearLongPressTimer() {
    if (this.action) {
      clearTimeout(this.action);
      this.action = null;
    }
  }

  private longPressAction() {
    this.clearLongPressTimer();
    this.action = setTimeout(() => {
      this.action = null;
      this.zone.run(() => {
        if (!this.longPressActive) {
          return;
        }
        this.longPressActive = false;
        this.blockNextActivation = true;
        setTimeout(() => this.blockNextActivation = false, 400);
        Haptics.impact({style: ImpactStyle.Medium});
        this.press.emit();
      });
    }, this.delay);
  }
}
